export default "__VITE_ASSET__BWyRZRQB__"